

import {
  CLICKED,
  LATEST_REQUEST,
  LOGOUT_USER,
  INITIAL_PAGE_LOAD,
} from '../constants';

const INIT_STATE = {
  lastClick:{document},
  clickId:false,
  networkClickId:"latest",
  latestRequest:false,
  windowRequest:false,
  initialLoad:false,
  pageLoad:true 
};

export default (state = INIT_STATE, action) => {
  
  switch (action.type) {
    case CLICKED:
      return { ...state, lastClick:action.payload.entity, clickId:action.payload.clickId};
    break;
    case LOGOUT_USER:
      return INIT_STATE;
      break;
    case LATEST_REQUEST:
      var retObj = {...state};
          retObj.latestRequest = action.payload;
          retObj.initialLoad = true;
      return retObj;
    break;
    case INITIAL_PAGE_LOAD:
      var retObj = {...state};
          retObj.pageLoad = !state.pageLoad ? "complete" : false;
          return retObj;
    default:
      return {...state}
    break;
  }
};
